import { useState } from 'react';
import { IconArrowUpRight, IconChecks, IconPlus, IconSparkles, IconX, IconCheck } from '@tabler/icons-react';
import { DockPanel, useDock } from '@hana/shell';
import { useT } from '@hana/i18n';
import { useToast } from '@hana/ui';
import './i18n';
import { AP_ROWS, BRIEF_CHIPS, BRIEF_SALE, MY_TASKS, type Grp } from './data';
import { MAIL_SALE, NOTIS_SALE } from './dock';
import s from './home.module.css';
import d from './dock.module.css';

// Mint-Home-1920 · N-04e: bảng phải 372 (≥ 1800 mở sẵn) — theo code board dk*: Tóm tắt đầu ngày + 3 tab Việc / Thông báo / Duyệt.
type K = 'task' | 'noti' | 'ap';
export const useHomeDock = () => useDock<K>('task');
const GRPS: readonly Grp[] = ['over', 'today', 'next'];
const NOTI_C = { warn: 'var(--d-amber)', err: 'var(--err)', pri: 'var(--d-blue)', ok: 'var(--d-green)', violet: 'var(--d-violet)' } as const;
const GRP_KEY = { over: 'hn.dk.grpOver', today: 'hn.dk.grpToday', next: 'hn.dk.grpNext' } as const;
const SLA = { warn: d.sWarn, err: d.sErr, tx: undefined } as const;

export function HomeDock({ dock, empty }: { dock: ReturnType<typeof useHomeDock>; empty: boolean }) {
  const t = useT();
  const toast = useToast();
  const tip = (m: string) => toast({ msg: m });
  const [done, setDone] = useState<Record<number, boolean>>({});
  const [mdone, setMdone] = useState<Record<string, boolean>>({});
  const [readAll, setReadAll] = useState(false);
  const [dec, setDec] = useState<Record<number, boolean>>({});
  if (!dock.open) return null;
  const tasks = empty ? [] : MY_TASKS;
  const unread = readAll || empty ? 0 : NOTIS_SALE.filter((n) => n[3]).length;
  const aps = (empty ? [] : AP_ROWS).filter((a) => !dec[a.id]);
  const mail = empty ? [] : MAIL_SALE;
  const tabs = [{ key: 'task' as const, label: t('hn.dk.tabTask'), n: tasks.length }, { key: 'noti' as const, label: t('hn.dk.tabNoti'), n: unread }, { key: 'ap' as const, label: t('hn.dk.tabAp'), n: aps.length }];
  return (
    <DockPanel tabs={tabs} tab={dock.tab} onTab={dock.show} onClose={dock.close} top={
    <section className={d.brief} aria-label={t('home.brief')}>
      <div className={d.bh}><span className={d.bi} aria-hidden="true"><IconSparkles size={16} stroke={1.8} /></span><b>{t('home.brief')}</b><span className={d.bt}>07:30</span></div>
      <p>{empty ? t('home.briefNone') : BRIEF_SALE}</p>
      <div className={d.chips}>{(empty ? [{ k: t('home.noTaskToday'), tone: 'n' as const }] : BRIEF_CHIPS).map((c) => <span key={c.k} className={`${d.chip} ${c.tone === 'err' ? s.cerr : c.tone === 'pri' ? s.cpri : s.cn}`}>{c.k}</span>)}</div>
      <button type="button" className={d.ask} onClick={() => tip(t('home.later'))}>{t('hn.dk.ask')}</button>
    </section>
    }>
      {dock.tab === 'task' && (
        <>
          <div className={d.meta}>{t('hn.dk.deleg')}</div>
          {!tasks.length && <div className={s.none}>{t('home.noToday')}</div>}
          {GRPS.map((g) => {
            const items = tasks.filter((x) => x.grp === g).slice(0, 4);
            if (!items.length) return null;
            return (
              <div key={g} className={d.grp}>
                <div className={`${d.gh} ${g === 'over' ? d.over : ''}`}>{t(GRP_KEY[g])} · {items.length}</div>
                {items.map((x) => (
                  <div key={x.id} className={`${d.card} ${done[x.id] ? d.fin : ''}`}>
                    <input type="checkbox" aria-label={t('hn.doneT', { t: x.title })} checked={!!done[x.id]} onChange={() => { setDone((v) => ({ ...v, [x.id]: !v[x.id] })); tip(done[x.id] ? t('hn.reopen', { c: x.code }) : t('hn.dk.doneC', { c: x.code })); }} />
                    <div className={d.cb}>
                      <div className={d.ct}>{x.code} · {x.title}</div>
                      <div className={d.cs}>{x.obj && <><a href="/ezy/jobs">{x.obj}</a> · </>}<span className={g === 'over' ? d.sErr : undefined}>{x.dueK} · {x.due}</span></div>
                    </div>
                    {g !== 'next' && <button type="button" className={d.ext} aria-label={t('hn.dk.extL')} title={t('hn.dk.extT', { x: x.ext })} onClick={() => tip(t('home.extDone'))}><IconPlus size={14} stroke={1.8} aria-hidden="true" />4h</button>}
                  </div>
                ))}
              </div>
            );
          })}
          {mail.length > 0 && <div className={d.mh}>{t('hn.dk.mailH', { n: mail.filter((m) => !mdone[m[0]]).length })}</div>}
          {mail.map((m) => (
            <div key={m[0]} className={`${d.card} ${mdone[m[0]] ? d.fin : ''}`}>
              <input type="checkbox" aria-label={t('hn.dk.mailDone', { m: m[3] })} checked={!!mdone[m[0]]} onChange={() => setMdone((v) => ({ ...v, [m[0]]: !v[m[0]] }))} />
              <div className={d.cb}><div className={`${d.ct} ${m[6] && !mdone[m[0]] ? d.unr : ''}`}>{m[1]} · {m[3]}</div><div className={d.cs}>{m[2]} · <span className={`${d.sla} ${SLA[m[5]] ?? ''}`}>{m[4]}</span></div></div>
              <a href="/box" className={d.open} aria-label={t('hn.dk.mailL', { m: m[3] })}><IconArrowUpRight size={16} stroke={1.8} aria-hidden="true" />{t('hn.open')}</a>
            </div>
          ))}
        </>
      )}
      {dock.tab === 'noti' && (
        <>
          {empty && <div className={s.none}>{t('hn.dk.noNoti')}</div>}
          {(empty ? [] : NOTIS_SALE).map(([k, when, c, unr], i) => (
            <div key={k} className={d.noti} style={{ borderTopWidth: i ? 1 : 0 }}><span className={d.dot} style={{ background: readAll || !unr ? 'var(--bd)' : NOTI_C[c] }} /><div><div className={unr && !readAll ? d.unr : undefined}>{k}</div><div className={d.cs}>{when}</div></div></div>
          ))}
          <button type="button" className={d.all} onClick={() => { setReadAll(true); tip(t('hn.dk.readAllDone')); }}><IconChecks size={16} stroke={1.8} aria-hidden="true" />{t('hn.dk.readAllDone')}</button>
        </>
      )}
      {dock.tab === 'ap' && (
        <>
          {!aps.length && <div className={s.none}>{t('hn.dk.noAp')}</div>}
          {aps.slice(0, 6).map((a) => (
            <div key={a.id} className={d.ap}>
              <div className={d.ah}><b>{a.title}</b></div>
              <div className={d.as}>{a.kind} · {a.by}</div>
              <div className={d.ab}>
                <button type="button" className={d.yes} onClick={() => { setDec((v) => ({ ...v, [a.id]: true })); tip(t('hn.agreed', { k: a.title })); }}><IconCheck size={16} stroke={1.8} aria-hidden="true" />{t('hn.dk.approve')}</button>
                <button type="button" className={d.no} onClick={() => tip(t('home.later'))}><IconX size={16} stroke={1.8} aria-hidden="true" />{t('hn.reject')}</button>
              </div>
            </div>
          ))}
        </>
      )}
    </DockPanel>
  );
}
